ScrollTrigger.refresh();

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<42;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_EZ_Cartridge_${i}.avif`;
    }
    for(let i=1;i<38;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_EZ_Cartridge_box7_${i}.avif?v=1732868317`;
    }
};
preloadImages()

if(window.innerWidth>750){
    var Wflag = true
}else{
    Wflag = false
    $('.box3_items a').click(function(event){
        event.preventDefault();
    })
}

new Swiper('.box5Swiper', {
	slidesPerView: 1.5,
    centeredSlides: true,
})


gsap.fromTo('.box2_info1 div:nth-child(1)',{x:'-50%'},{
    x:'0',
    scrollTrigger:{
        trigger:'.box2',
        scrub:1,
        end:'bottom center',
    }
})
gsap.fromTo('.box2_info1 div:nth-child(2)',{x:'50%'},{
    x:'0',
    scrollTrigger:{
        trigger:'.box2',
        scrub:1,
        end:'bottom center',
    }
})

ScrollTrigger.create({
    trigger:'.box5',
    start:'top bottom-=20%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box5_title').addClass('showup');
    },
    onLeaveBack: () => {
        $('.box5_title').removeClass('showup');
    }
})

if(Wflag){
    ScrollTrigger.create({
        trigger:'.box5',
        start:'top center-=10%',
        end:'+=0',
        // markers:true,
        toggleActions:'play none none reverse',
        animation:gsap.timeline().from('.box5_items div:nth-child(1)',{x:'135%',duration:0.5,ease:'none'})
        .from('.box5_items div:nth-child(3)',{x:'-135%',duration:0.5,ease:'none'},'<')
    }) 
}



ScrollTrigger.create({
    trigger:'.box6',
    start:'top bottom-=20%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box6_title').addClass('showup');
    },
    onLeaveBack: () => {
        $('.box6_title').removeClass('showup');
    }
})

if(Wflag){
    gsap.timeline({
        scrollTrigger:{
            trigger:'.box6',
            start:'top+=10% top+=6%',
            end:'+=200%',
            scrub:1,
        }
    }).to('.box6_items',{x:'-66%'})
    ScrollTrigger.create({
        trigger:'.box6',
        start:'top top+=6%',
        end:'+=250%',
        pin:true,
        // markers:true,
    }) 
}

ScrollTrigger.create({
    trigger:'.box7',
    start:'top bottom-=20%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box7_title').addClass('showup');
    },
    onLeaveBack: () => {
        $('.box7_title').removeClass('showup');
    }
})

ScrollTrigger.create({
    trigger:'.box7',
    start:'top top+=15%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        box7_start()
    }
})

var box7_i = 1;
var box7_flag;
function box7_start(){
    box7_flag =  setInterval(box7_zhuan,40)
}
function box7_zhuan(){
    box7_i++;
    $('.box7_img img').attr('src',`https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_EZ_Cartridge_box7_${box7_i}.avif?v=1732868317`)
    if(box7_i==37){
        box7_i = 1
        clearInterval(box7_flag)
    }
}

ScrollTrigger.create({
    trigger:'.box3',
    start:'top bottom-=20%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box3_title').addClass('showup');
    },
    onLeaveBack: () => {
        $('.box3_title').removeClass('showup');
    }
})

ScrollTrigger.create({
    trigger:'.box8',
    start:'top center',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box8_title').addClass('showup');
    },
    onLeaveBack: () => {
        $('.box8_title').removeClass('showup');
    }
})

ScrollTrigger.create({
    trigger:'.box8',
    start:'top center',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box8_img').css({transform:'scale(1)'})
    },
    onLeaveBack: () => {
        $('.box8_img').css({transform:'scale(0)'})
    }
})

// 获取根元素的字体大小
let rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
var remValue = -3.75 * rootFontSize;

let controller1 = new ScrollMagic.Controller();

let scene1 = new ScrollMagic.Scene({
    offset: remValue,
    triggerElement: '.box1',
    triggerHook: "0",
    duration:1200,
})
scene1.setPin('.box1')
scene1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    // 60
    for(let i=1;i<42;i++){
        if(index>i*1.5){
            $('.box1_img').attr('src',`https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_EZ_Cartridge_${i}.avif`)
        }
    }
    if(index>70){
        $('.box1_title').removeClass('showup')
        if(index<85){
            $('.box1_content').css({background:`rgba(0,0,0,${mapValue(index,70,85,0,0.8)})`})
            $('.box1_item').removeClass('showup')
        }else{
            $('.box1_content').css({background:`rgba(0,0,0,0.8)`})
            $('.box1_item').addClass('showup')
        }
    }else{
        $('.box1_content').css({background:`rgba(0,0,0,0)`})
        $('.box1_title').addClass('showup')
    }
})

let scene2_1 = new ScrollMagic.Scene({
    offset: remValue,
    triggerElement: '.box2_1',
    triggerHook: "onenter",
    duration:0,
})
scene2_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box2_info2 .box2_items:nth-child(1)').addClass('showup')
    $('.box2_info2 .box2_items:nth-child(2)').css({transitionDelay:'0.5s',transform:'translateY(0)',opacity:'1'})
    if(index<2){
        $('.box2_info2 .box2_items:nth-child(1)').removeClass('showup')
        $('.box2_info2 .box2_items:nth-child(2)').css({transitionDelay:'0s',transform:'translateY(2rem)',opacity:'0'})
    }
})

controller1.addScene([scene1,scene2_1]); 

//boxSpecs_btn
$('.boxSpecs_btn').click(function(){
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_buy').click(function(){ 
    //window.open(''); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})
